export default __webpack_public_path__ + "static/G2Logo-80eea0885746a12d05b54432c4f57f0c.svg";